import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "batch";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    async getBatchList({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingBatch/?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //新增批次
    async addBatch({ commit }, payload) {
      let result = await api.post("/api/WeighingBatch", payload);
      return result;
    },
    //变更状态
    async updateStatus({ commit }, payload) {
      let result = await api.post(
        "/api/WeighingBatch/UpdateBatchStatus",
        payload
      );
      return result;
    },
    //获取单个批次信息
    async getSingleView({ commit }, payload) {
      let result = await api.get(`/api/WeighingBatch/${payload}`);
      return result.data;
    },
    // 删除批次
    async deleteBatch({ commit }, payload) {
      let result = await api.delete(`/api/WeighingBatch/${payload}`);
      return result;
    },
    // 删除批次明细
    async deleteBatchDetail({ commit }, payload) {
      let result = await api.delete(
        `/api/WeighingBatch/BatchDetail/${payload}`
      );
      return result;
    },
    //生成系统批次号
    async generateSysBatchNo({ commit }) {
      let result = await api.get(`/api/WeighingBatch/GenerateSysBatchNo`);
      return result.data;
    },
    // 获取批次号下的产品列表
    async getProductListByBatch({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingProductReport/GetProductListByBatch?batchNo=${payload}`
      );
      return result.data;
    },
    // 获得批次报表
    async getWeighingBatchReport({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingProductReport/GetWeighingBatchReport?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
  },
  mutations: {},
  getters: {},
});

export default moduleName;
